export default {
  title: 'Revisión de Datos',
  subtitle: 'Mira en gráficos los datos de tu Data Template aprobado antes de empezar a modelar. Busca períodos faltantes, picos repentinos y series que no coincidan con lo que sabes de tu negocio.',
  uploadedBy: 'subido por {name} el {date}',
  templateApprovedBy: 'aprobado por {name} el {date}',
  statusPending: 'Pendiente de revisión',
  statusApproved: 'Aprobada',
  validationWarnings: 'Este template se aprobó con {count} advertencia de validación. | Este template se aprobó con {count} advertencias de validación.',
  viewInDataUpload: 'Verlas en Carga de Datos',

  // States
  noTemplateTitle: 'Todavía no hay un Data Template aprobado',
  noTemplateText: 'Sube tu Data Template y apruébalo en Carga de Datos; luego vuelve aquí para revisarlo.',
  goToDataUpload: 'Ir a Carga de Datos',
  loadingTitle: 'Preparando tus datos…',
  loadingText: 'Estamos leyendo tu template y sumando cada serie.',
  loadingSlowText: 'Los templates grandes pueden tardar unos minutos. Puedes dejar esta página abierta.',
  errorTitle: 'No pudimos preparar tus datos',
  errorText: 'Inténtalo de nuevo. Si sigue fallando, contacta a nuestro equipo.',
  errorPermission: 'No tienes acceso a la Revisión de Datos de este modelo.',
  errorNotApproved: 'El Data Template ya no está aprobado. Apruébalo primero en Carga de Datos.',
  errorDisabled: 'La carga de datos no está habilitada para este modelo.',
  retry: 'Reintentar',

  // Tiles
  tileDateRange: 'Rango total de fechas',
  tileFrequency: 'Frecuencia de ventas',
  tileSeries: 'Series',
  tileSheetsWithData: 'Hojas con datos',
  tileSheetsOf: '{count} de {total}',
  tileFlagged: 'Series a revisar',
  tileNone: 'Ninguna',
  frequencyDaily: 'Diaria',
  frequencyWeekly: 'Semanal',
  frequencyMonthly: 'Mensual',
  frequencyQuarterly: 'Trimestral',
  frequencyYearly: 'Anual',
  frequencyIrregular: 'Irregular',

  // Sheet groups
  groupKpi: 'Ventas y KPIs',
  groupOwn: 'Marketing propio',
  groupCompetition: 'Competencia',
  groupContext: 'Mercado y contexto',
  groupSpecialDates: 'Fechas especiales',
  specialDatesEmpty: 'Este template no tiene fechas especiales',
  eventsHeaderStart: 'Inicio',
  eventsHeaderEnd: 'Fin',
  eventsHeaderEvent: 'Evento',
  eventsHeaderDescription: 'Descripción',
  eventsTruncated: 'Solo se listan las primeras 500 fechas especiales.',

  // Approval
  approvalTitle: 'Aprobar la Revisión de Datos',
  approvalText: 'Cuando los gráficos se vean bien, aprueba la Revisión de Datos. Nuestro equipo recibirá un aviso y seguirá con el modelo.',
  approvalCheckbox: 'Revisé los gráficos y los datos se ven correctos',
  approveButton: 'Aprobar Revisión de Datos',
  approvedTitle: 'Revisión de Datos aprobada',
  approvedText: 'Aprobada por {name} el {date}. Nuestro equipo ya recibió el aviso.',
  markAsPending: 'Volver a pendiente',
  approvedSnackbar: 'Revisión de Datos aprobada. Nuestro equipo ya recibió el aviso.',
  pendingSnackbar: 'La Revisión de Datos volvió a pendiente.',
  approvalError: 'No se pudo actualizar la Revisión de Datos. Inténtalo de nuevo.',

  // Footer
  generatedAt: 'Gráficos preparados el {date}',
  partialNotice: 'Se omitieron algunos detalles para que la página cargue rápido.'
}
